import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';
import { SiteState } from './site.state';
import { Site } from '../model/site.model';

export function avecSélecteursSites<_>() {
  return signalStoreFeature(
    {
      state: type<SiteState & EntityState<Site>>(),
      props: type<EntityProps<Site> & { selectedEntity: Signal<Site | null> }>(),
    },
    // Pagination
    withComputed(({ paginator, entities }) => ({
      getPaginated: computed(() =>
        entities().slice((paginator.pageNb() - 1) * paginator.pageSize(), paginator.pageNb() * paginator.pageSize()),
      ),
      totalPageNb: computed(() => Math.ceil(entities().length / paginator.pageSize()) || 1),
      firstItemNumber: computed(() => {
        if (entities().length === 0) {
          return 0;
        }
        return (paginator.pageNb() - 1) * paginator.pageSize() + 1;
      }),
      lastItemNumber: computed(() => {
        if (paginator.pageNb() === Math.ceil(entities().length / paginator.pageSize())) {
          return entities().length;
        }
        return paginator.pageNb() * paginator.pageSize();
      }),
      count: computed(() => entities().length),
    })),
  );
}
